import React, { MouseEventHandler } from 'react';
import { Modal } from '../ui/modal';
import WarningIcon from '../../public/icons/warning-big.svg';
import { Button } from '../ui/button';

type Props = {
  open: boolean;
  handleClose: MouseEventHandler<HTMLButtonElement>;
  existingCustomer: { id: number; name: string; assigned_user_name: string };
  handleDateModalOpen: Function
};

const CustomerExistsModal = ({
  open,
  handleClose,
  existingCustomer,
  handleDateModalOpen
}: Props) => {
  const { id, assigned_user_name } = existingCustomer;

  const handleSchedule = (e) => {
    handleClose(e);
    handleDateModalOpen(null, id);
  }
  return (
    <Modal open={open} handleClose={handleClose}>
      <div className="w-full flex flex-col gap-4 items-center justify-between">
        <WarningIcon />
        <div className="flex flex-col gap-3">
          <p className="font-bold text-xl text-center">This contact Already Exists</p>
          {assigned_user_name && (
            <p className="text-primary-dark text-base text-center">
            This contact already exist with the owner -{' '}
            <span className='font-bold'>{assigned_user_name}</span>. Do you want to schedule a
            meeting?
          </p>
          )} 
        </div>

        <div className="!w-full flex gap-4">
          <Button variant='tertiary' className="w-full" onClick={handleClose}>Cancel</Button>
          <Button variant='secondary' className="w-full" onClick={handleSchedule}>Schedule Now</Button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomerExistsModal;
